// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3vO4f","detailsBorder":"styles_detailsBorder__2CuZy"};